/*
 * @Author: 李明明
 * @Date: 2023-12-13 15:52:29
 * @LastEditTime: 2024-05-17 11:26:18
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /pc用户端/jctt-pc/src/utils/utils.js
 * 代码版权方：'政府采购信息网'
 */
// 获取url中的参数
export function getUrlParams(key) {
  const params = new URLSearchParams(window.location.href.split("?")[1]);
  return params.get(key) || "";
}

// 获取分享人信息
export function setShareInfo() {
  let codeStamp = getUrlParams("codeStamp");
  if (codeStamp) {
    // 把codeStamp存起来
    let shareUserInfo = { codeStamp };
    localStorage.setItem("shareUserInfo", JSON.stringify(shareUserInfo));
  }
}

// 获取分享地址
export function getShareUrl() {
  let id = getUrlParams("id");
  let url = `https://m.jcaitt.com/#/pages/goods/goods?id=${id}`;
  // 测试环境
  if (location.host.includes("test")) {
    url = `https://testm.jcaitt.com/#/pages/goods/goods?id=${id}`;
  }

  let params = {};

  let shareUserInfo = localStorage.getItem("shareUserInfo") || null;

  if (shareUserInfo) {
    params = { ...JSON.parse(shareUserInfo) };
  } else {
    let userInfo = localStorage.userInfo && JSON.parse(localStorage.userInfo);
    if (userInfo) {
      // 这里codeStamp参数是用户登录时返回的userInfo中的id
      params = { codeStamp: userInfo.id };
    }
  }
  const search = new URLSearchParams(Object.entries(params));
  let paramsStr = search.toString();

  if (paramsStr) {
    console.log("⚽ => 分享的url", `${url}&${paramsStr}`);
    return `${url}&${paramsStr}`;
  } else {
    console.log("⚽ => 分享的url", url);
    return url;
  }
}

function GetUrlParam(paraName) {
  var url = document.location.toString();
  var arrObj = url.split("?");

  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;

    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}

export function skip(url) {
  console.log(url);
  var mobileAgent = new Array(
    "iphone",
    "ipod",
    "ipad",
    "android",
    "mobile",
    "blackberry",
    "webos",
    "incognito",
    "webmate",
    "bada",
    "nokia",
    "lg",
    "ucweb",
    "skyfire"
  );
  var browser = navigator.userAgent.toLowerCase();
  var isMobile = false;
  for (var i = 0; i < mobileAgent.length; i++) {
    if (browser.indexOf(mobileAgent[i]) != -1) {
      isMobile = true;
      if (/#\/list?/.test(url)) {
        let id = GetUrlParam("id");
        if (/www.jcaitt/.test(url)) {
          location.href = `https://m.jcaitt.com/#/pages/goodsList/goodsList?id=${id}`;
        } else {
          location.href = `https://testm.jcaitt.com/#/pages/goodsList/goodsList?id=${id}`;
        }
        console.log(123);
      } else {
        if (/www.jcaitt/.test(url)) {
          location.href = url.replace("www", "m");
        } else {
          console.log(url.replace("http://localhost:8080", "testm.jcaitt"));
          location.href = url.replace("testwww", "testm");
          location.href = url.replace("localhost:8080", "testm.jcaitt.com");
        }
      }
      break;
    }
  }
}

/**
 * 版本检查工具类
 * 功能：
 * 1. 比对本地版本与线上版本
 * 2. 如果版本不一致则刷新页面进行静态资源重载
 * 3. 打印本地版本和远端版本信息
 * 
 * 特别说明：针对qiankun微前端环境进行了适配
 */
export const VersionChecker = {
  /**
   * 执行版本检查
   * @param {string|object} options - 线上版本文件URL或配置对象
   * @param {number} refreshDelay - 检测到新版本后延迟刷新的毫秒数，默认为1000ms
   * @returns {Promise<void>}
   */
  async checkVersion(options, refreshDelay = 1000) {
    try {
      // 解析参数
      let onlineVersionUrl = null;
      let appName = null;
      
      if (typeof options === 'string') {
        // 如果传入的是字符串，则视为线上版本URL
        onlineVersionUrl = options;
      } else if (typeof options === 'object') {
        // 如果传入的是对象，则解析配置
        onlineVersionUrl = options.onlineVersionUrl;
        appName = options.appName;
        refreshDelay = options.refreshDelay || refreshDelay;
      }
      
      // 获取本地版本信息
      const localVersion = await this.getLocalVersion();
      
      // 获取线上版本信息
      const onlineVersion = await this.getOnlineVersion(onlineVersionUrl, appName);
      
      // 打印版本信息
      this.logVersionInfo(localVersion, onlineVersion);
      
      // 比较版本并刷新页面（如果需要）
      if (localVersion && onlineVersion && this.isDifferentVersion(localVersion, onlineVersion)) {
        console.log('⚠️ 检测到新版本，正在刷新页面以获取最新代码...');
        // 延迟刷新，以便用户看到控制台信息
        setTimeout(() => {
          // 在微前端环境中，需要考虑子应用的刷新方式
          if (window.__POWERED_BY_QIANKUN__) {
            console.log('在微前端环境中，通知主应用刷新子应用...');
            // 这里可以根据qiankun的API通知主应用刷新子应用
            // 例如: window.location.reload();
            window.location.reload();
          } else {
            // 移除URL中的hash部分，确保完全刷新
            const cleanUrl = window.location.href.split('#')[0];
            // 使用replace避免添加到浏览器历史记录
            window.location.replace(cleanUrl);
            // 强制刷新
            window.location.reload(true);
          }
        }, refreshDelay);
      } else {
        console.log('✅ 当前已是最新版本，无需刷新');
      }
    } catch (error) {
      console.error('版本检查过程中发生错误:', error);
    }
  },
  
  /**
   * 获取本地版本信息 - 适配qiankun微前端环境
   * @returns {Promise<object|null>}
   */
  getLocalVersion() {
    return new Promise((resolve) => {
      try {
        // 根据环境选择版本文件名：生产环境使用version.json，测试环境使用version.test.json
        const versionFileName = process.env.NODE_ENV === 'production' ? 'version.json' : 'version.test.json';
        
        // 在qiankun微前端环境中，获取子应用自身的版本文件
        // window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ 是qiankun注入的子应用的publicPath
        const versionJsonPath = window.__POWERED_BY_QIANKUN__ && window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ 
          ? `${window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__}${versionFileName}`
          : `./${versionFileName}`;
        
        console.log('获取本地版本信息的路径:', versionJsonPath);
        
        fetch(versionJsonPath)
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('获取本地版本文件失败');
          })
          .then(data => {
            // 添加来源标记，方便调试
            data.source = 'local';
            resolve(data);
          })
          .catch(error => {
            console.warn('无法获取本地版本信息:', error);
            resolve(null);
          });
      } catch (error) {
        console.warn('获取本地版本过程中发生错误:', error);
        resolve(null);
      }
    });
  },
  
  /**
   * 获取线上版本信息
   * @param {string} onlineUrl - 线上版本文件URL
   * @param {string} appName - 子应用名称，如 'ykt-course'
   * @returns {Promise<object|null>}
   */
  getOnlineVersion(onlineUrl, appName) {
    return new Promise((resolve) => {
      try {
        // 根据环境选择版本文件名：生产环境使用version.json，测试环境使用version.test.json
        const versionFileName = process.env.NODE_ENV === 'production' ? 'version.json' : 'version.test.json';
        
        let finalOnlineVersionUrl = onlineUrl;
        
        // 如果没有提供onlineUrl，则使用默认路径
        if (!finalOnlineVersionUrl) {
          // 默认使用相对路径
          finalOnlineVersionUrl = `/${versionFileName}`;
          
          // 如果提供了appName，则在路径中包含appName
          if (appName) {
            finalOnlineVersionUrl = `/${appName}/${versionFileName}`;
          }
          
          console.log('[版本检查] 使用默认线上版本URL:', finalOnlineVersionUrl);
        } else {
          console.log('[版本检查] 使用提供的线上版本URL:', finalOnlineVersionUrl);
        }
        
        console.log('[版本检查] 获取线上版本信息的URL:', finalOnlineVersionUrl);
        
        fetch(finalOnlineVersionUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('获取线上版本文件失败');
          })
          .then(data => {
            // 添加来源标记，方便调试
            data.source = 'remote';
            resolve(data);
          })
          .catch(error => {
            console.warn('[版本检查] 无法获取线上版本信息:', error);
            resolve(null);
          });
      } catch (error) {
        console.warn('[版本检查] 获取线上版本过程中发生错误:', error);
        resolve(null);
      }
    });
  },
  
  /**
   * 比较两个版本是否不同
   * @param {object} localVersion - 本地版本信息
   * @param {object} onlineVersion - 线上版本信息
   * @returns {boolean}
   */
  isDifferentVersion(localVersion, onlineVersion) {
    // 简单比较版本号字符串
    // 在实际应用中，您可能需要实现更复杂的版本比较逻辑
    if (!localVersion || !onlineVersion) return false;
    
    // 比较版本号字段
    return String(localVersion.version || '') !== String(onlineVersion.version || '');
  },
  
  /**
   * 打印版本信息
   * @param {object} localVersion - 本地版本信息
   * @param {object} onlineVersion - 线上版本信息
   */
  logVersionInfo(localVersion, onlineVersion) {
    console.log('=====================================');
    console.log('📱 [本地版本信息]');
    if (localVersion) {
      this.printVersionDetails(localVersion);
    } else {
      console.log('无法获取本地版本信息');
    }
    
    console.log('-------------------------------------');
    console.log('🌐 [线上版本信息]');
    if (onlineVersion) {
      this.printVersionDetails(onlineVersion);
    } else {
      console.log('无法获取线上版本信息');
    }
    console.log('=====================================');
  },
  
  /**
   * 打印版本详情
   * @param {object} versionInfo - 版本信息对象
   */
  printVersionDetails(versionInfo) {
    // 打印所有版本相关字段
    Object.keys(versionInfo).forEach(key => {
      // 格式化输出，使对齐更美观
      const keyStr = key.padEnd(10, ' ');
      console.log(`  ${keyStr}: ${versionInfo[key]}`);
    });
  }
}
